import React from 'react';
import { Panel, Empty } from '../../components/Primitives';
import { useFetch } from '../../lib/hooks';
import { fmtUsd, fmtNum, fmtDate } from '../../lib/api';

export default function Orders() {
  const { data: orders } = useFetch('/orders', [], 30000);
  return (
    <div data-testid="orders-page">
      <Panel title="Orders & Executions (Paper Trading)">
        {orders && orders.length ? (
          <div className="overflow-x-auto"><table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-vj-grey border-b border-border">
              <th className="py-2 font-medium">Symbol</th><th className="font-medium">Side</th><th className="font-medium">Qty</th><th className="font-medium">P&L</th><th className="font-medium">Fee</th><th className="font-medium">Source</th><th className="font-medium">Date</th>
            </tr></thead>
            <tbody>{orders.map((o) => (
              <tr key={o.id} className="border-b border-border last:border-0">
                <td className="py-2.5 font-mono">{o.symbol}</td><td className="capitalize">{o.side}</td>
                <td className="font-mono">{fmtNum(o.qty, 4)}</td>
                <td className={`font-mono ${Number(o.pnl) >= 0 ? 'text-vj-neon' : 'text-vj-red'}`}>{fmtUsd(o.pnl)}</td>
                <td className="font-mono text-vj-grey">{fmtUsd(o.fee)}</td>
                <td className="text-xs uppercase text-vj-gold">{o.source}</td>
                <td className="text-xs text-vj-grey">{fmtDate(o.created_at)}</td>
              </tr>
            ))}</tbody>
          </table></div>
        ) : <Empty>No orders yet. Activate the S.I. Bot to generate paper trades.</Empty>}
      </Panel>
    </div>
  );
}
